module.exports = __webpack_public_path__ + "img/nubeDerecha.c896d665.svg";